import { Controller } from "react-hook-form";
import Select from "../ui-components/select";
import classnames from "classnames";

const SelectField = (props) => {
  const {
    errors,
    label = "",
    name,
    options,
    disabled = false,
    control,
    className = "",
    placeholder = "",
    helpText = "",
    required = false
  } = props;

  const message = errors && errors[name]?.message;

  const renderError = () => {
    return (
      message && (
        <small className="block text-danger" data-cy={`error-${name}`}>
          {message}
        </small>
      )
    );
  };
  return (
    <div className={classnames("mb-3", { [className]: className })}>
      {label && (
        <label htmlFor={name}>
          {label}
          {required && <span className="font-bold text-danger">*</span>}
        </label>
      )}
      <Controller
        name={name}
        control={control}
        render={({ field: { value, onChange } }) => (
          <Select
            id={name}
            name={name}
            className="w-full"
            value={value}
            options={options}
            disabled={disabled}
            invalid={Boolean(message)}
            helpText={helpText}
            placeholder={placeholder || "Select"}
            onChange={onChange}
          />
        )}
      />
      {renderError()}
    </div>
  );
};

export default SelectField;
